import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__